import React, { useEffect, useState } from 'react'
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap'
import UserChat from './UserChat'
import { enumUtil } from '../../../utils/Enum'
import isNull from '../../../utils/NullChecking'
import { ServerRequestProtected } from '../../../utils/ServerDataRequest'
import Loader from '../../../Components/shared/Loader/Loader'
const UsersWithPastChat = ({ users, connection, senderUserID, senderUserName, PracticeID, isOpenFromNewChat, newUserInfo, setUsers, userimages, ForwardedMesg, forawardedMessage, ClearForwardMesg }) => {
    // main tab names and there ids just to remember
    //  UserChatWithPastChats , Userlisting id: 1
    //  UserChat                            id: 2
    const API_URL = enumUtil.controller.Messages

    const [isLoading, setIsLoading] = useState(false)
    const [receiverUserID, setReceiverUserID] = useState(0)
    const [receiverUserName, setReceiverUserName] = useState(0)
    const SeenAllMessages = (id) => {
        if (connection) {
            connection.invoke("MarkMessagesAsSeen", id + "").catch(err => console.error(err.toString()));
        }
    }
    const [userImage, setUserImage] = useState('')

    const [mainActivetab, setmainActivetab] = useState('1')
    const handleOpenUser = (data) => {
        SeenAllMessages(data.ReceiverID)
        setReceiverUserID(data.ReceiverID)
        setReceiverUserName(data.LastName + ',' + data.FirstName)
        const RecvierImg = getUserImageURL(data.ReceiverID)
        setUserImage(RecvierImg)
    }
    // handle active users 
    const [activeTab, setActiveTab] = useState(null);
    const [activeTabs, setActiveTabs] = useState([]);
    const toggle = (item) => {
        handleOpenUser(item)
        // setUserImage(item.ProfilePictureURL)
        let tab = item.ReceiverID
        if (!activeTabs.includes(tab)) {
            setActiveTabs([...activeTabs, tab]);
        }
        setActiveTab(tab);
        setmainActivetab('2')
    };
    useEffect(() => {
        if (isOpenFromNewChat) {
            toggle(newUserInfo)
        }
    }, [isOpenFromNewChat])
    const UpdateChatList = (user, message, time, count, firstname, lastname) => {
        const now = new Date();
        const currentTime = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        setUsers(prevUsers => {
            // Find the index of the user being updated
            const userIndex = prevUsers.findIndex(item => item.ReceiverID + "" === user + "");

            // User doesn't exist → add new user at the top
            if (userIndex === -1) {
                const newUser = {
                    ReceiverID: user,
                    MessageContent: message,
                    TimeAgo: time,
                    UnseenMessages: count,
                    FirstName: firstname,
                    LastName: lastname
                };

                return [newUser, ...prevUsers];
            }

            // Create updated user object
            const updatedUser = {
                ...prevUsers[userIndex],
                MessageContent: message || prevUsers[userIndex].MessageContent,
                TimeAgo: time,
                UnseenMessages: count,
            };

            // Create new array without the updated user
            const otherUsers = prevUsers.filter((_, index) => index !== userIndex);

            // Return new array with updated user at top
            return [updatedUser, ...otherUsers];
        });
    };
    useEffect(() => {
        if (connection) {
            connection.on("UpdateChatList", (user, message, time, count, firstname, lastname) => {
                UpdateChatList(user, message, time, count, firstname, lastname)
                // setMessages(prevMessages => [...prevMessages, newMessage]);
            });
        }
        if (connection) {
            connection.on("UpdateChatforUser", (user, message, time, count) => {
                if (!isNull(user)) {
                    UpdateChatList(user, message, time, count)
                }
                // setMessages(prevMessages => [...prevMessages, newMessage]);
            });
        }
    }, [connection]);
    useEffect(() => {
        if (mainActivetab === '1') {
            // connection.invoke("UpdateChatList", receiverUserID + "").catch(err => console.error(err.toString()));
        }
    }, [mainActivetab])

    const getUserImage = (ReceiverID) => {
        const userImage = userimages.find(image => image.ReceiverID + "" === ReceiverID + "");
        if (!isNull(userImage?.ProfilePictureURL)) {
            return <img src={userImage?.ProfilePictureURL} alt="" />
        } else {
            const userInitials = users.find(item => item.ReceiverID + "" === ReceiverID + "");
            let frstletter = userInitials?.FirstName ? userInitials?.FirstName[0] : ''
            let lstletter = userInitials?.LastName ? userInitials?.LastName[0] : ''
            if (!isNull(frstletter) && !isNull(lstletter)) {
                return <p className={`align-items-center d-flex h-100 heading justify-content-center w-100 fs-14`}>
                    {lstletter + frstletter}
                </p>
            }

        }
        // ? (userImage.Image.startsWith('data:image/')
        //     ? userImage.Image
        //     : `data:image/jpeg;base64,${userImage.Image}`)
        // : '';
    }
    const getUserImageURL = (ReceiverID) => {
        const userImage = userimages.find(image => image.ReceiverID + "" === ReceiverID + "");
        return userImage?.ProfilePictureURL
    }
    // delete user chat
    const handleDeleteChat = (item) => {
        // setIsLoading(true)
        setUsers(prevUsers =>
            prevUsers.filter(user => user.ReceiverID !== item.ReceiverID)
        );
        ServerRequestProtected(API_URL + "/DeleteChat", 'post', {
            "TableName": "Messages",
            "SenderID": senderUserID,
            "ReceiverID": item.ReceiverID + "",
            "PracticeID": PracticeID + ""
        }).then((response) => {
            // setIsLoading(false)

        }).catch((error) => {
            // setIsLoading(false)
        })
    }
    return (
        <>
            {/*  user listing */}
            {mainActivetab === '1' ?
                <div className='za-new-conversation-screen messaging position-relative'>
                    {/* {isLoading ? <Loader /> : null} */}
                    <div className='za-content'>
                        <div className='za-cards'>
                            <Nav className='d-flex flex-column hover-scrollbar gap-10'>
                                {users && users.map((item, idx) => (
                                    <NavItem>
                                        <NavLink className={activeTab === item.ReceiverID ? 'active' : ''} onClick={() => { toggle(item) }}>
                                            <div className='za-card d-flex justify-content-between align-items-center gap-2' key={item.id} >
                                                <div className='d-flex align-items-center justify-content-center gap-2' onClick={() => handleOpenUser(item)}>
                                                    <div className="img-container s-35 circle">
                                                        {getUserImage(item.ReceiverID)}
                                                        {/* <img src={item.ProfilePictureURL ? item.ProfilePictureURL : "https://www.w3schools.com/howto/img_avatar.png"} alt="https://www.w3schools.com/howto/img_avatar.png" /> */}
                                                    </div>
                                                    <div>
                                                        <p className={` ${item.UnseenMessages === 0 ? 'text font-m' : 'heading'}`} >{item.LastName} {item.FirstName}</p>
                                                        <p className={`singleLine-ellispis ${item.UnseenMessages === 0 ? 'text font-r fs-11 ar-light-color' : 'text font-r fs-11'}`}>{item.MessageContent}</p>
                                                    </div>
                                                </div>
                                                <div className='d-flex flex-column align-items-end time-delete'>
                                                    <p className={`text font-r fs-11 text-nowrap ${item.UnseenMessages === 0 ? "ar-light-color" : 'orange-drk'}`}>{item.TimeAgo}</p>
                                                    {item.UnseenMessages == 0 ? null : <p className='ar_count heading'>{item.UnseenMessages}</p>}
                                                    <i className='icon-delete text-danger d-none' onClick={(e) => { e.stopPropagation(); handleDeleteChat(item); }}></i>
                                                </div>
                                            </div>
                                        </NavLink>
                                    </NavItem>
                                ))}
                            </Nav>
                            {/* Dilivierd messages */}
                            {/* <div className='za-card d-flex justify-content-between align-items-center'>
                                <div className='d-flex align-items-center justify-content-center gap-1'>
                                    <div className="img-container s-35 circle">
                                        <img src="https://www.w3schools.com/howto/img_avatar.png" alt="" />
                                    </div>
                                    <div className=''>
                                        <p className='heading'>Alex john</p>
                                        <p className='text font-m fs-10 ar-light-color '>Will Do this latter on Unread</p>
                                    </div>
                                </div>

                                <div className='d-flex flex-column align-items-end gap-01'>
                                    <p className='text font-m fs-10 ar-light-color'>2h ago</p>
                                    <i className="bi bi-check-all"></i>
                                </div>
                            </div> */}
                            {/* seen messages */}
                            {/* <div className='za-card d-flex justify-content-between align-items-center'>
                                <div className='d-flex align-items-center justify-content-center gap-1'>
                                    <div className="img-container s-35 circle">
                                        <img src="https://www.w3schools.com/howto/img_avatar.png" alt="" />
                                    </div>
                                    <div className=''>
                                        <p className='heading'>Alex john</p>
                                        <p className='text font-m fs-10 ar-light-color '>Will Do this latter on Read</p>
                                    </div>
                                </div>

                                <div className='d-flex flex-column align-items-end'>
                                    <p className='text font-m fs-10 ar-light-color'>2h ago</p>
                                    <i className="bi bi-check-all seen"></i>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
                : mainActivetab === '2' ?
                    < TabContent activeTab={activeTab}>
                        {activeTabs.map(tab => (
                            <TabPane key={tab} tabId={tab}>
                                <UserChat
                                    setmainActivetab={setmainActivetab}
                                    senderUserID={senderUserID}
                                    senderUserName={senderUserName}
                                    receiverUserName={receiverUserName}
                                    receiverUserID={receiverUserID}
                                    PracticeID={PracticeID}
                                    connection={connection}
                                    ForwardedMesg={ForwardedMesg}
                                    forawardedMessage={forawardedMessage}
                                    ClearForwardMesg={ClearForwardMesg}
                                    userImage={userImage}
                                />
                            </TabPane>
                        ))}
                    </TabContent >
                    : null
            }
        </>
    )
}

export default UsersWithPastChat